import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import GlobalStyles from './global-style';

import { fetchData } from './state/slices/data';

import PageWrap from './views/pagewrap';
import store from './state/store';

const container = document.getElementById('foot');
const root = createRoot(container);

// Prod https://d11zrgpbhs014a.cloudfront.net/2026/iran-war-events-map/index.html
// Stage https://naca-embeds-stg.s3.ap-southeast-2.amazonaws.com/2026/iran-war-events-map/index.html

const element = (
  <Provider store={store}>
    <GlobalStyles />
    <PageWrap />
  </Provider>
);

root.render(element);

/* Initial data fetch */
store.dispatch(fetchData());
